import React from 'react';
import pictureTransgender from "./images/transgender.png";
import Icon from "../../../../../components/Icon";
import {Link} from "react-router-dom";

const CategoriesGender = (props) => {

    return (
        <section id="pict-gender">
            <div className="taggage-media-main-content-title">
                <img src={pictureTransgender} alt="" />
                <h1>Vérifier le genre des photos</h1>
            </div>

            <p className="taggage-media-main-content-description">Vérifiez le genre pré-sélectionné
                et corrigez les erreurs. Identifiez les trio, groupes, hommes travestis ou
                transexuels, et indiquez N/A lorsque la photo ne représente pas un humain (objet,
                paysage...)</p>

            <div className="taggage-media-main-content-genders">
                {props.childrens.filter(subCategory => subCategory.totalModeration > 0).map(subCategory =>(
                    <div key={subCategory._id} className={`taggage-media-main-content-genders-card ${subCategory.slug}`}>
                        <div className="taggage-media-main-content-genders-card-color">
                            <p className="taggage-media-main-content-genders-card-color-gender">{subCategory.title}</p>
                            <Link to={`${props.currentUrl}-photo/${subCategory._id.toString()}`} className="count-media-cta">
                                <div className="count-media">
                                    <Icon type={"picture-2"} size={"w-20"} className={"mr-4"} />
                                    <p>{subCategory.totalModeration || 0}<br /><span>médias</span></p>
                                </div>
                                <Icon type={"arrow-right-2"} size={"w-20"} className={"mr-4"} />
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
};

export default CategoriesGender;